import { Component, OnInit } from '@angular/core';
import { LookUpService } from 'src/app/services/lookup.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  dateYear = new Date().getFullYear();
  youtube: string | undefined;
  twitter: string | undefined;
  linkedin: string | undefined;
  instagram: string | undefined;
  faceBook: string | undefined;
  email: string | undefined;
  phone: string | undefined;
  phone2: string | undefined;
  phone3: string | undefined;
  logo: string | undefined;
  footerImageScharfesicht: string | undefined;
  download_Url_Android: string | undefined;
  download_Url_Huawei: string | undefined;
  download_Url_Ios: string | undefined;
  footer_Text: string | undefined;
  footer_TextScharfesicht: string | undefined;
  homePage_Section8: string | undefined;
  footer: string | undefined;
  constructor(public service: LookUpService
  ) { }
  getLogo(): string | null {
    return localStorage.getItem('logo');
  }
  getAddressText(): string | null {
    return localStorage.getItem('addressText');
  }
  getfaceBook(): string | null {
    return localStorage.getItem('faceBook');
  }
  getinstagram(): string | null {
    return localStorage.getItem('instagram');
  }
  getlinkedin(): string | null {
    return localStorage.getItem('linkedin');
  }
  getyoutube(): string | null {
    return localStorage.getItem('youtube');
  }

  ngOnInit(): void {
    this.service.getAll$().subscribe(x => {
      this.footer = x.find(x => x?.name == "FooterText")?.value;
      this.phone = x.find(x => x?.name == "Phone")?.value;
      this.phone2 = x.find(x => x?.name == "Phone2")?.value;
      this.phone3 = x.find(x => x?.name == "Phone3")?.value;
      this.twitter = x.find(x => x?.name == "Twitter")?.value;
      this.instagram = x.find(x => x?.name == "Instagram")?.value;
      this.faceBook = x.find(x => x?.name == "FaceBook")?.value;
      this.linkedin = x.find(x => x?.name == "Linkedin")?.value;
      this.youtube = x.find(x => x?.name == "Youtube")?.value;
      this.logo = x.find(x => x?.name == "Logo")?.value;
    });

  }
  openSocalMediaNewWindow(id: string | undefined) {
    this.service.openSocalMediaNewWindow(id);
  }
  createImgPath = (serverPath: string) => {
    return this.service.createImgPath(serverPath);
  }

}
